import React from 'react';
import { connect } from 'react-redux';
import { setView, setUsername, setPassword, logoutUser, toggleUnsavedViewModal } from '../../../actions';
import TimeDisplay from './TimeDisplay';
import LiveSideBar from './LiveSideBar';

const SideBar = props => {
  const {
    view ,
    user,
    editMode,
    setView,
    setUsername,
    setPassword,
    logoutUser,
    toggleUnsavedViewModal,
  } = props

  const buttonClicked = (button) => {
    let onClose = null
    if (button === 'logout') {
      onClose = logout
    } else {
      onClose = () => setView(button)
    }

    if (editMode) {
      toggleUnsavedViewModal(true, onClose)
    } else {
      onClose()
    }
  }

  const logout = () => {
    setUsername('')
    setPassword('')
    logoutUser()
  }

  return (
    <div style={styles.container}>
      <TimeDisplay />

      {/* view will eather be one of these only for now */}
      {view === 'live' && <LiveSideBar />}

      <div style={styles.buttonContainer}>
        <button onClick={() => setView('live')} style={{...styles.button, ...(view === 'live' && styles.selectedButton)}} >Live</button>
        <button className="track-changes" onClick={(e) => buttonClicked('playback')} style={{...styles.button, ...(view === 'playback' && styles.selectedButton)}} >Playback</button>
        {(user.bRole === 1 || user.bRole === 2) && <button className="track-changes" onClick={() => buttonClicked('admin')} style={{...styles.button, ...(view === 'admin' && styles.selectedButton)}} >Setup</button>}
        <button onClick={() => setView('utilities')} style={{...styles.button, ...(view === 'utilities' && styles.selectedButton)}} >Utilities</button>
        <button className="track-changes" onClick={() => buttonClicked('logout')} style={styles.button} >Logout</button>
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  const { view, layoutConfig } = state.config;
  const { user } = state.auth;
  const { editMode } = state.live;
  return {
    view,
    layoutConfig,
    user,
    editMode,
  }
}

export default connect(mapStateToProps, {
  setView,
  setUsername,
  setPassword,
  logoutUser,
  toggleUnsavedViewModal,
})(SideBar);

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    textAlign: 'center',
    backgroundColor: 'rgba(10, 14, 25, 0.6)',
    borderRadius: 5,
    width: '10vw',
    marginLeft: '5vw',
    padding: '2vmin 1vmin',
    color: 'white',
    fontSize: '1.5vmin',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '1vmin',
    width: '100%',
  },
  button: {
    cursor: 'pointer',
    padding: '3px 10px',
    width: '100%',
    overflow: 'hidden',
    borderRadius: '5px',
    fontSize: '1.5vmin',
  },
  selectedButton: {
    backgroundColor: 'rgb(56, 172, 236)',
  },
}